const withRenderedMain = require('components-framework/view/with_rendered_main');
const SeatsTracking = require('../../../../webapp/static-content/_versionedByRelease_/js/tracking/bags_and_seats/seats_tracking').getInstance();

module.exports = withRenderedMain(Backbone.View.extend(Odigeo._.extend({
    initialize(options) {
        this.scrollToFirstSeatType = options.scrollToFirstSeatType;
        this.analyticsEventTracking = options.analyticsEventTracking;
        this.updateSeatTypes(options.seatAvailabilityByType);
    },
    events: {
        'tap .legend_clickable_type': 'onTapSeatType',
    },
    onTapSeatType: function(e) {
        const seatType = $(e.currentTarget).data('type');
        this.scrollToFirstSeatType(seatType);
        SeatsTracking.trackTapLegend(seatType);
    },
}, require('./view'))));
